export const APP_NAME_TEST = 'testDapp';
export const PROJECT_ID_TEST = 'e57fb0f09f867d067a8abde02ba4aff4';

export const APP_NAME = 'Schrodinger';
export const PROJECT_ID = '811bcb9a54e77f810328ee9fa35208c3';
